import styled from "styled-components";

/**Graph Chart */

export const GraphCardSC = styled.div`
	padding: 18px 24px;

	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.75rem;
	flex: 1;

	min-width: 300px;

	border-radius: 15px;
	border: 1px solid var(--color-10, #eeefff);
	background: #fcfbfb;
`;
export const GraphInnerContainerSC = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	width: 100%;
`;
export const GraphBodySC = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	width: 100%;
	justify-content: center;
`;
export const GraphTitleSC = styled.span`
	color: var(--text-1, #303030);
	font-family: IBM Plex Sans;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	text-align: center;
	width: 100%;
	line-height: normal;
	align-self: start;
`;
export const GraphSubTitleSC = styled.span`
	color: var(--text-1, #303030);
	font-family: IBM Plex Sans;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;
export const GraphPieSC = styled.div`
	height: 100%;
`;

export const GraphLegendSC = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;
export const GraphLegendItemSC = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const GraphLegendLabelSC = styled.div`
	width: 10px;
	height: 10px;
	content: "";

	border-radius: 2px;
	background: var(--error, ${props => props.color});
`;
export const GraphLegendTitleSC = styled.div`
	color: var(--text-50, #676767);
	font-family: IBM Plex Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 23px; /* 164.286% */
	letter-spacing: -0.28px;
`;
export const GraphLegendSubtitleSC = styled.div`
	color: var(--text-50, #676767);
	font-family: IBM Plex Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 23px; /* 164.286% */
	letter-spacing: -0.28px;
`;

export const GraphVersusBarSC = styled.div`
	width: 160px;
	height: 10px;
	content: "";

	border-radius: 2px;
	border: 1px solid #e6e6e6;
	background: var(--error, #e6e6e6);
`;
export const GraphVersusBarInnerSC = styled.div`
	width: ${props => props.width + "%" || 0};
	height: 8px;
	content: "";

	border-radius: 2px;
	background: var(--error, #7f26f2);
`;
